import {
  type PublicEmailDomainsResponse,
  publicEmailDomainsResponseDto,
  type UpdatePublicEmailDomainsBody,
} from '@planuze/admin-contracts';
import { ApiError, parseJson, readErrorCode, request } from './http.js';

/* Cliente REST dos domínios de email públicos (ADR-0569). GET lê a lista LIVE do
   config-service; PUT (super_admin) substitui a lista inteira via read-modify-write no
   admin-service (preserva as demais chaves do config). */

async function domainsError(res: Response): Promise<ApiError> {
  const code = await readErrorCode(res);
  return new ApiError(res.status, 'server_error', code || 'request failed', code);
}

export async function getPublicEmailDomains(): Promise<readonly string[]> {
  const res = await request('/v1/admin/public-email-domains');
  if (!res.ok) throw await domainsError(res);
  return (await parseJson(res, publicEmailDomainsResponseDto)).domains;
}

export async function updatePublicEmailDomains(
  body: UpdatePublicEmailDomainsBody,
): Promise<PublicEmailDomainsResponse> {
  const res = await request('/v1/admin/public-email-domains', { method: 'PUT', body });
  if (!res.ok) throw await domainsError(res);
  return parseJson(res, publicEmailDomainsResponseDto);
}
